import { useCallback } from 'react'

import { useGetCustomerForClient } from '@lyrahealth-inc/shared-app-logic/src/features/providers/hooks/useGetCustomerForClient'

import useFetchClientEligibility, { EligibilityResponse } from './useFetchClientEligibility'
import { useAppDispatch } from '../data/store'
import { useCustomersForClient } from '../lyraTherapy/clients/clientDetails/data/hooks/useCustomersForClient'
import { useSelectedClientData } from '../lyraTherapy/clients/clientDetails/data/hooks/useSelectedClientData'
import { checkEligibility } from '../requestPayment/data/requestPaymentActions'

export const useEapEligibilityError = ({
  programName,
  isEnabled = true,
}: {
  programName?: string
  isEnabled?: boolean
}) => {
  const dispatch = useAppDispatch()
  const { data: clientDetails } = useSelectedClientData()
  const customers = useCustomersForClient()
  const clientCustomer = useGetCustomerForClient(customers, clientDetails)

  const checkEligibilityWrapper = useCallback(
    (data: FormData): Promise<EligibilityResponse> =>
      (dispatch as any)(checkEligibility(data)) as Promise<EligibilityResponse>,
    [dispatch],
  )

  const shouldFetchEligibility = Boolean(
    isEnabled &&
    clientDetails?.country === 'US' &&
    clientCustomer?.eap_eligibility_check_enabled === 'true' &&
    !!programName,
  )

  return useFetchClientEligibility({
    clientDetails: clientDetails ?? null,
    checkEligibility: checkEligibilityWrapper,
    shouldFetchEligibility,
    programName,
  })
}
